import { useContext } from 'react';
import { useOutletContext, useNavigate } from 'react-router-dom';
import GlobalContext from "../context/GlobalContext.js";
import DesktopNavBar from './DesktopNavBar.js';
import { darkenColor } from '../functions/colorUtils.js';
import { Home as HomeIcon, ChevronDown, ArrowLeft } from 'lucide-react';

export default function HeaderBackground({ pageTitle, pageSubtitle, onBack, rightAction }) {
    const { theme, settings } = useContext(GlobalContext);
    const primaryColor = settings?.primary_hex_colour || '#813468';
    const outletContext = useOutletContext() || {};
    const { unreadCount, agreementId, agreementAddress, layoutLoading } = outletContext;
    const navigate = useNavigate();

    const gradientStyle = theme !== 'highContrast'
        ? { background: `linear-gradient(135deg, ${primaryColor}, ${darkenColor(primaryColor)})` }
        : undefined;

    const agreementLeftSlot = layoutLoading ? (
        <div className="bg-white/20 backdrop-blur-md rounded-full px-2 py-1.5">
            <div className="flex items-center gap-2 rounded-full px-3 py-2">
                <HomeIcon size={14} className="text-white/30 flex-shrink-0" />
                <span className="text-sm font-medium text-transparent"><span className="inline-block animate-pulse bg-white/30 rounded w-36 h-full">&nbsp;</span></span>
                <ChevronDown size={14} className="text-white/30 flex-shrink-0" />
            </div>
        </div>
    ) : agreementAddress ? (
        <div className="bg-white/20 backdrop-blur-md rounded-full px-2 py-1.5">
            <button
                onClick={() => navigate('/home')}
                className="flex items-center gap-2 rounded-full px-3 py-2 text-white/90 hover:bg-white/15 transition-colors"
                title={agreementAddress}
            >
                <HomeIcon size={14} className="flex-shrink-0" />
                <span className="text-sm font-medium truncate max-w-[400px]">{agreementAddress}</span>
                <ChevronDown size={14} className="text-white/70 flex-shrink-0" />
            </button>
        </div>
    ) : null;

    return (
        <>
            {/* Mobile: gradient strip with optional back button + centered page title */}
            <div
                className={"lg:hidden h-16 w-screen flex items-center justify-center relative" + (theme === 'highContrast' ? ' bg-black' : '')}
                style={gradientStyle}
            >
                {onBack && (
                    <button
                        onClick={onBack}
                        className="absolute left-3 p-2 text-white/90 hover:text-white transition-colors"
                        aria-label="Go back"
                    >
                        <ArrowLeft size={22} />
                    </button>
                )}
                {pageTitle && (
                    <div className="flex flex-col items-center">
                        <h1 className="text-white font-semibold text-lg tracking-tight">{pageTitle}</h1>
                        {pageSubtitle && (
                            <p className="text-white/70 text-xs mt-0.5">{pageSubtitle}</p>
                        )}
                    </div>
                )}
                {rightAction && (
                    <div className="absolute right-3">
                        {rightAction}
                    </div>
                )}
            </div>

            {/* Desktop: gradient strip with nav bar */}
            <div
                className={"hidden lg:block w-full" + (theme === 'highContrast' ? ' bg-black' : '')}
                style={gradientStyle}
            >
                <div className="max-w-5xl mx-auto py-3">
                    <DesktopNavBar
                        unreadCount={unreadCount}
                        agreementId={agreementId}
                        leftSlot={agreementLeftSlot}
                    />
                </div>
            </div>
        </>
    );
}
